import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const STORAGE_KEY = "nidoria-cookie-consent";

export default function CookieBanner() {
  const [choice, setChoice] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return "rejected";
    }
  });

  const decide = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      /* almacenamiento no disponible */
    }
    setChoice(value);
  };

  return (
    <AnimatePresence>
      {!choice && (
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 32 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-4 bottom-4 z-50 rounded-3xl border border-[#12263a]/10 bg-white/95 p-5 pr-20 shadow-2xl backdrop-blur-md dark:border-white/10 dark:bg-[#102336]/95 sm:left-6 sm:right-auto sm:max-w-md sm:pr-5"
          role="dialog"
          aria-label="Aviso de cookies"
          data-testid="cookie-banner"
        >
          <p className="text-sm font-bold text-[#12263a] dark:text-[#f7f4ee]">Usamos cookies</p>
          <p className="mt-1.5 text-xs leading-relaxed text-[#12263a]/60 dark:text-[#f7f4ee]/55">
            Utilizamos cookies propias y de terceros para mejorar tu experiencia. Puedes aceptarlas o rechazarlas.{" "}
            <Link to="/cookies" className="font-bold text-[#0f766e] underline dark:text-[#14b8a6]" data-testid="cookie-banner-more-info">
              Más información
            </Link>
          </p>
          <div className="mt-4 flex gap-2.5">
            <button
              onClick={() => decide("accepted")}
              data-testid="cookie-accept-button"
              className="rounded-full bg-[#0f766e] px-5 py-2.5 text-xs font-extrabold text-white transition-transform duration-200 hover:scale-[1.04] active:scale-95"
            >
              Aceptar
            </button>
            <button
              onClick={() => decide("rejected")}
              data-testid="cookie-reject-button"
              className="rounded-full border border-[#12263a]/20 px-5 py-2.5 text-xs font-extrabold text-[#12263a] transition-colors duration-200 hover:border-[#0f766e] hover:text-[#0f766e] dark:border-white/20 dark:text-[#f7f4ee] dark:hover:border-[#14b8a6] dark:hover:text-[#14b8a6]"
            >
              Rechazar
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
